import { useTranslation } from "react-i18next";
import { AtSign } from "lucide-react";
import type { ThreadsPresets as ThreadsPresetsData, ThreadsReplyControl } from "@shared/schema";
import { PresetSection, PresetSelect } from "./PresetSection";

export function ThreadsPresets({
  value,
  onChange,
}: {
  value: ThreadsPresetsData;
  onChange: (next: ThreadsPresetsData) => void;
}) {
  const { t } = useTranslation();
  return (
    <PresetSection
      icon={<AtSign size={14} className="text-white/70" />}
      title={t("contentScheduler.presets.threads.title")}
    >
      <PresetSelect
        label={t("contentScheduler.presets.threads.replyControl")}
        value={value.replyControl}
        onChange={(next: ThreadsReplyControl) => onChange({ ...value, replyControl: next })}
        options={[
          { value: "everyone", label: t("contentScheduler.presets.threads.replyEveryone") },
          {
            value: "accounts_you_follow",
            label: t("contentScheduler.presets.threads.replyFollowed"),
          },
          { value: "mentioned_only", label: t("contentScheduler.presets.threads.replyMentioned") },
        ]}
      />
    </PresetSection>
  );
}
